import { LoDashStatic } from "lodash";
import { Moment } from "moment";

// tslint:disable:no-var-requires
require("babel-polyfill");
require("./poshytip/styles/tip-twitter/poshytip.css");
require("@fortawesome/fontawesome-pro/css/all.min.css");
require("./poshytip/styles/tip-twitter/tip-twitter.css");
require("./jquery.contextmenu/styles/contextmenu.z.css");
require("./jquery.contextmenu/styles/jquery.contextmenu.css");
require("./leaflet/styles/leaflet.less");
require("./leaflet/styles/Control.FullScreen.less");
require("./console");
window.$ = (window as any).jQuery = require("jquery");
require("../../Content/app/less/font.less");
require("./kendo");
require("./bootstrap/css/bootstrap-theme.css");
require("./bootstrap/css/bootstrap.css");
require("./bootstrap/css/bootstrap-sub-menu.css");
require("./bootstrap/css/bootstrap.z.css");
require("./bootstrap/js/bootstrap");
window._ = require("lodash");
require("oidc-client");
window.moment = require("moment");
require("moment-timezone");
window.JSZip = require("jszip");
require("./poshytip/jquery.poshytip");
window.base64js = require("base64-js");